import { Deserializer } from "jsonapi-serializer";

import { Category } from "../models/Categories";
import { genericError } from "../models/GenericError";
import { ListQuery } from "../models/ListQuery";
import { CategoriesWrapper } from "../models/wrappers/CategoryWrapper";
import { APIConnector } from "./api/APIConnector";
import { processServerError, getConstraintViolation } from "./utilities/ServiceError";
import { getFilterClause, getSortByClause } from "./utilities/urlBuilder";

const apiConnector = new APIConnector();

export const getCategories = async ( listParameters?: ListQuery ): Promise<CategoriesWrapper> => {
    try {
        const urlBase = `profile?include=site`;
        const includePageTotals = "&page[totals]";
        const goToPageNumber = !listParameters?.goToPage ? "" : "&page[number]=" + listParameters?.goToPage;
        const withPageSize = !listParameters?.pageSize ? "" : "&page[size]=" + listParameters?.pageSize;
        const withSortBy = getSortByClause(listParameters?.sortBy);

        const personCategoryFilter = {
            key: 'profileType.id',
            label: 'Profile type', // not displayed
            options: [{ label: '3', value: '3' }],
            selected: [{ label: '3', value: '3' }]
        }

        const withFilters = getFilterClause(
            [...listParameters?.filters ?? [], personCategoryFilter],
            listParameters?.searchTerm
        );

        const url = urlBase + goToPageNumber + withPageSize + includePageTotals + withSortBy + withFilters;
        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const meta = json.meta;
        const paginationModel = {
            totalCount: !!meta ? meta.page.totalRecords : 0,
            maxPageSize: !!meta ? meta.page.limit : 0,
            totalPages: !!meta ? meta.page.totalPages : 0,
            pageNumber: !!meta ? meta.page.number : 0,
        };

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }

            new Deserializer().deserialize(json, (err: any, apiCategories: any[]) => {
                if (err) {
                    return reject({status: response.status, message: genericError });
                }

                const categories: Category[] = apiCategories.map((c): Category => {
                    return {
                        id: c["id"],
                        name: c["trn-name"],
                        site: c["site"]["site-name"],
                        enrolments: c["total-masters"],
                        isDefault: c['is-default']
                    };
                });

                return resolve({ rows: categories, pagination: paginationModel });
            });
        });
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
};
